import { Button, styled } from 'tamagui';

export const HeaderButton = styled(Button, {
  maxWidth: '100%',
  backgroundColor: 'transparent',
  paddingLeft: 0,
  fontSize: '$2',
  width: '100%',
  justifyContent: 'flex-start',
});
